import { Skeleton } from "@synapse-analytics/synapse-ui"

import styles from "./ScreenSkeleton.module.scss"

const ScreenSkeleton = () => {
  return (
    <div className={styles.wrapper}>
      <Skeleton width="280px" height="32px" />
      <Skeleton width="600px" height="40px" />
      <Skeleton width="100%" height="calc(100vh - 200px)" />
    </div>
  )
}

export default ScreenSkeleton
